import { useTranslation } from "react-i18next";
import { BareSelect } from "@/atoms/bare-select";
import { supportedLngs } from "@/localization/options";
import { languageOwnName } from "@/utils/language";

/**
 * The language control in the Gymkee Pay bar (pay-brand-bar 1.1 anatomy.language).
 *
 * A language is a value that stays chosen, so it is select 1.8 in its bare variant (reuse.pay):
 * the current language in its own name and the chevron; select's popover from 640 and its sheet
 * on a phone. It sits at the right of the bar, above the sheet and outside it, never in the coach
 * header, where it once truncated the seller's name.
 *
 * No flags anywhere: a flag names a country and a language is not one.
 */

export function LanguageControl() {
  const { t, i18n } = useTranslation();
  const current = (i18n.resolvedLanguage ?? i18n.language).split("-")[0];

  return (
    <BareSelect
      label={t("gymkeePay.common.languageMenu")}
      value={current}
      options={supportedLngs.map((code) => ({
        value: code,
        label: languageOwnName(code),
      }))}
      onChange={(next) => void i18n.changeLanguage(next)}
    />
  );
}
